
import { Vue, Component } from 'vue-property-decorator';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { Header } from '@/models/main';
import { getJobHistory } from '@/api';
import { JobHistory as JobHistoryType } from '@/models/jobDetailed';
import { timeZoneDefault } from '@/utils/PortalConstants';
import { format, utcToZonedTime } from 'date-fns-tz';

@Component({
  components: {
    BackButton,
  },
})
export default class JobHistory extends Vue {
  private jobHistory: JobHistoryType[] = [];
  private isLoading = false;
  private headers: Header[] = [
    { text: 'Source', value: 'source', align: 'left' },
    { text: 'Time', value: 'action_time', align: 'left', sortable: true },
    { text: 'Message', value: 'change_message', align: 'left', sortable: false },
    { text: 'User', value: 'user', align: 'left', sortable: false },
  ];
  private jobId: number;
  private jobDate: string;

  /** on created hook. gets job id and date from URL */
  private created() {
    // Set job_id & job_date
    if (this.$route.query.job_id) {
      this.jobId = Number(this.$route.query.job_id);
    }
    if (this.$route.query.job_date) {
      this.jobDate = String(this.$route.query.job_date);
    }
    if (this.jobId && this.jobDate) {
      this.getJobHistory(this.jobId, this.jobDate);
    }
  }

  /** get date from API and format time at Sydney TZ */
  private getJobHistory(id: number, date: string) {
    this.isLoading = true;
    getJobHistory(id, date)
      .then(res => {
        this.isLoading = false;
        this.jobHistory = res;
        this.jobHistory.forEach(item => {
          item.action_time = format(utcToZonedTime(item.action_time, timeZoneDefault), 'yyyy-MM-dd HH:mm:ss');
        });
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
